// extracted by mini-css-extract-plugin
export default {"trendingTab":"trending_trendingTab__mvKHh"};